module.exports = __webpack_public_path__ + "static/img/10areaB_09.d6bf9fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_09.png
// module id = 1088
// module chunks = 1